import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["crossorigin"]
const _hoisted_2 = ["src", "crossorigin"]

import { computed, withDefaults, onMounted, ref, watch } from 'vue'
import dummyImg4to3 from '@/assets/images/dummy_800x600.png'
import loadingImg4to3 from '@/assets/images/loading_800x600.gif'
import dummyImg16to9 from '@/assets/images/dummy_800x450.png'
import loadingImg16to9 from '@/assets/images/loading_800x450.gif'

type PropsType = {
  src?: string | null
  width?: string
  useLazyLoad?: boolean
  crossOrigin?: string
  aspectRatio?: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Thumbnail',
  props: {
    src: null,
    width: { default: '160px' },
    useLazyLoad: { type: Boolean, default: true },
    crossOrigin: null,
    aspectRatio: { default: '4:3' }
  },
  emits: ['click'],
  setup(__props: any) {

const props = __props as { src?: string | null, width: string, useLazyLoad: boolean, crossOrigin?: string, aspectRatio: string };





const imgPath = ref<string>()

onMounted(() => {
  if (!props.useLazyLoad && props.src) {
    loadImg(props.src)
  }
})

const imgObj = computed(() => {
  // 画像がない場合はエラー画像を出す
  if (!props.src) {
    return {
      src: errorImg.value,
    }
  }
  return {
    src: props.src,
    error: errorImg.value,
    loading: loadingImg.value,
  }
})

const errorImg = computed<string>(() => {
  switch (props.aspectRatio) {
    case '16:9':
      return dummyImg16to9
    default:
      return dummyImg4to3
  }
})

const loadingImg = computed<string>(() => {
  switch (props.aspectRatio) {
    case '16:9':
      return loadingImg16to9
    default:
      return loadingImg4to3
  }
})

const style = computed<{ width: string }>(() => ({
  width: props.width,
}))

const loadImg = (v: string) => {
  imgPath.value = v
}

const error = () => {
  imgPath.value = errorImg.value
}

watch(
  () => props.src,
  (value) => {
    if (!props.useLazyLoad && value) {
      loadImg(value)
    }
  }
)

return (_ctx: any,_cache: any) => {
  const _directive_lazy = _resolveDirective("lazy")!

  return (__props.useLazyLoad)
    ? _withDirectives((_openBlock(), _createElementBlock("img", {
        key: 0,
        style: _normalizeStyle(_unref(style)),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('click'))),
        crossorigin: __props.crossOrigin
      }, null, 12, _hoisted_1)), [
        [_directive_lazy, _unref(imgObj)]
      ])
    : (_openBlock(), _createElementBlock("img", {
        key: 1,
        src: imgPath.value,
        style: _normalizeStyle(_unref(style)),
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('click'))),
        onError: error,
        crossorigin: __props.crossOrigin
      }, null, 44, _hoisted_2))
}
}

})